import {
  Sprout,
  Monitor,
  Receipt,
  Landmark,
  GraduationCap,
  Briefcase,
  Tractor,
  HeartHandshake,
  Rocket,
  Leaf,
  BookOpen,
  HeartPulse,
  Handshake,
} from "lucide-react";

export const SERVICES = [
  {
    slug: "agricultural-consultancy",
    num: "01",
    title: "Agricultural Consultancy",
    icon: Sprout,
    fee: 199,
    tagline: "Expert guidance for crops, soil and better yields",
    desc: "One-on-one sessions with agriculture advisors covering crop selection, soil health, pest management, mandi pricing and modern farming practices for small and marginal farmers.",
    eligibility: ["Open to all farmers and landholders", "Small and marginal farmers are given priority slots"],
    documents: ["Aadhaar card", "Land records or khasra copy (if available)"],
  },
  {
    slug: "digital-csc-support",
    num: "02",
    title: "Digital & CSC Support",
    icon: Monitor,
    fee: 99,
    tagline: "Help with online forms, certificates and portals",
    desc: "Assisted digital services: online applications, certificates, DigiLocker setup, PAN and Aadhaar updates, and government portal submissions through our trained operators.",
    eligibility: ["Open to all citizens", "Free for senior citizens above 70 years"],
    documents: ["Aadhaar card", "Mobile number linked with Aadhaar"],
  },
  {
    slug: "gst-business-guidance",
    num: "03",
    title: "GST & Business Guidance",
    icon: Receipt,
    fee: 299,
    tagline: "GST registration, returns and compliance help",
    desc: "Guided GST registration, return filing, invoicing basics and compliance support for small traders, shopkeepers and self-employed professionals.",
    eligibility: ["Small business owners and self-employed workers", "New registrations and existing GSTIN holders"],
    documents: ["PAN card", "Aadhaar card", "Bank account details", "Address proof of business"],
  },
  {
    slug: "government-scheme-guidance",
    num: "04",
    title: "Government Scheme Guidance",
    icon: Landmark,
    fee: 0,
    tagline: "PM-KISAN, pensions, housing and scholarships",
    desc: "Free guidance on central and state welfare schemes — eligibility checks, application filing, status tracking and grievance follow-up for PM-KISAN, pensions, housing, scholarships and more.",
    eligibility: ["Open to all citizens", "Scheme-specific eligibility explained during the session"],
    documents: ["Aadhaar card", "Bank passbook", "Relevant certificates (income, caste, age) where applicable"],
  },
  {
    slug: "training-skill-development",
    num: "05",
    title: "Training & Skill Development",
    icon: GraduationCap,
    fee: 499,
    tagline: "Hands-on courses for employable skills",
    desc: "Structured training batches in tailoring, computer basics, mobile repair and other locally demanded trades, with completion certificates and placement guidance.",
    eligibility: ["Age 16 and above", "BPL families eligible for fee waiver"],
    documents: ["Aadhaar card", "Education certificate (highest completed)", "Two passport-size photos"],
  },
  {
    slug: "employment-support",
    num: "06",
    title: "Employment & Self-Employment Support",
    icon: Briefcase,
    fee: 0,
    tagline: "Job linkage, resumes and livelihood planning",
    desc: "Free support for job seekers: resume building, interview preparation, job-mela updates, apprenticeship linkage and self-employment planning with local opportunities.",
    eligibility: ["Open to all job seekers aged 18 and above", "Special desk for women returning to work"],
    documents: ["Aadhaar card", "Education and experience certificates"],
  },
  {
    slug: "agriculture-rural-development",
    num: "07",
    title: "Agriculture & Rural Development",
    icon: Tractor,
    fee: 0,
    tagline: "Village-level programs and FPO support",
    desc: "Community programs for rural development: farmer-producer organisation support, watershed and irrigation guidance, and linkage with agriculture department programs.",
    eligibility: ["Farmer groups, FPOs and village committees", "Individual farmers welcome"],
    documents: ["Group registration details (for FPOs)", "Aadhaar card of applicant"],
  },
  {
    slug: "social-welfare",
    num: "08",
    title: "Social Welfare & Community Development",
    icon: HeartHandshake,
    fee: 0,
    tagline: "Support for vulnerable families and communities",
    desc: "Community welfare assistance: ration card and pension support, widow and disability welfare linkage, community events and volunteer coordination.",
    eligibility: ["Open to all; priority for BPL and vulnerable households", "Community groups and volunteers welcome"],
    documents: ["Aadhaar card", "BPL or ration card (if available)"],
  },
  {
    slug: "entrepreneurship-support",
    num: "09",
    title: "Entrepreneurship & Business Support",
    icon: Rocket,
    fee: 299,
    tagline: "Start and grow your own venture",
    desc: "Business planning, Udyam registration, loan and subsidy scheme linkage (MUDRA, PMEGP), bookkeeping basics and mentoring for first-generation entrepreneurs.",
    eligibility: ["Aspiring and existing entrepreneurs", "SHG members encouraged to apply"],
    documents: ["Aadhaar card", "PAN card", "Business idea note or existing business proof"],
  },
  {
    slug: "environmental-awareness",
    num: "10",
    title: "Environmental Awareness",
    icon: Leaf,
    fee: 0,
    tagline: "Tree drives, waste management and clean water",
    desc: "Free awareness programs on tree plantation, waste segregation, water conservation and clean-energy adoption for schools, colonies and village committees.",
    eligibility: ["Schools, RWAs and village committees", "Individual volunteers welcome"],
    documents: ["No documents required"],
  },
  {
    slug: "education-digital-literacy",
    num: "11",
    title: "Education & Digital Literacy",
    icon: BookOpen,
    fee: 0,
    tagline: "Learn computers, smartphones and safe internet",
    desc: "Free foundational courses: smartphone use, email, UPI and safe online payments, plus guidance for school and scholarship applications for students.",
    eligibility: ["Open to all ages", "Beginner-friendly; no prior computer knowledge needed"],
    documents: ["Aadhaar card", "Student ID (for scholarship guidance)"],
  },
  {
    slug: "health-awareness",
    num: "12",
    title: "Health Awareness",
    icon: HeartPulse,
    fee: 0,
    tagline: "Preventive care camps and health education",
    desc: "Free health awareness camps with basic checkups, nutrition guidance, vaccination information and linkage to Ayushman Bharat and state health schemes.",
    eligibility: ["Open to all", "Camps held monthly; group bookings for communities"],
    documents: ["Aadhaar card (for scheme linkage only)"],
  },
  {
    slug: "institutional-collaboration",
    num: "13",
    title: "Government, NGO, CSR & Institutional Collaboration",
    icon: Handshake,
    fee: 0,
    tagline: "Partner with NUC Service for programs",
    desc: "Collaboration desk for government departments, NGOs, CSR teams and institutions to co-design and execute development programs with transparent reporting.",
    eligibility: ["Registered organisations, departments and CSR teams", "MoU-based long-term partnerships available"],
    documents: ["Organisation registration certificate", "Authorised signatory ID proof"],
  },
];

export const serviceBySlug = (slug) => SERVICES.find((s) => s.slug === slug);
